/* Organizations that show the Liberty logo in the top-right corner (title screen and game). Everyone else sees no logo. */
const LOGO_ORGANIZATIONS = []; // logo switched off: add organization ids here to show it again
const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/hoc/assets`;

export const logoFor = (organizationId) => (LOGO_ORGANIZATIONS.includes(organizationId) ? `${ASSET_BASE}/logo/liberty_logo.png` : undefined);
